import styled from "styled-components";

interface LinearGradiente {
  primary: string;
  secondary: string;
}

export const Padding = styled.div`
  padding-right: 6px;
  margin-top: 2px;
`;

export const HeaderForm = styled.div<LinearGradiente>`
  display: flex;
  align-items: center;
  min-height: 98px;
  border-radius: 16px;
  padding: 10px 32px 10px 32px;
  margin: 0px 56px 0px 56px;
  background-image: ${(props) =>
    `linear-gradient(to right, ${props.primary}, ${props.secondary})`};
  position: relative;
  top: 20px;
  z-index: 1;
`;
export const Left = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 90%;
`;
export const Rigth = styled.div`
  display: flex;
  width: 10%;

  img {
    max-width: 80%;
    padding: 0;
    margin: 0;
  }
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-right: 20px;
  p {
    font-family: Inter;
    color: white;
    font-weight: 700;
  }
  small {
    font-family: Inter;
    font-size: 12px;
    color: white;
  }
  @media only screen and (max-width: 600px) {
    margin-bottom: 8px;
    p {
      margin-top: 10px;
    }
  }
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
    margin-bottom: 8px;
  }
  img {
    margin-right: 8px;
  }
`;
export const Space = styled.div`
  height: 16px;
`;
export const RowTemperature = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
`;
